import { useCallback, useEffect, useState } from 'react'

import { UndoableAction } from '@/core/app-builder/undo/types'
import constate from '@/lib/constate'
import { useAppClientContext } from '@/context/__project__/AppClientContext'

const [UndoRedoProvider, useUndoRedoContext] = constate('UndoRedoContext', () => {
  const { appClient } = useAppClientContext()

  const [canUndo, setCanUndo] = useState(false)
  const [canRedo, setCanRedo] = useState(false)
  const [undoStack, setUndoStack] = useState<UndoableAction[]>([])
  const [redoStack, setRedoStack] = useState<UndoableAction[]>([])

  // Handle undo action
  const handleUndo = useCallback(async () => {
    if (!appClient) return
    try {
      await appClient.Undo()
    } catch (error) {
      console.error('Undo failed:', error)
    }
  }, [appClient])

  // Handle redo action
  const handleRedo = useCallback(async () => {
    if (!appClient) return
    try {
      await appClient.Redo()
    } catch (error) {
      console.error('Redo failed:', error)
    }
  }, [appClient])

  // Subscribe to undo/redo stack changes
  useEffect(() => {
    if (!appClient) return

    const unsubscribe = appClient.undoManager.subscribe((undo, redo) => {
      setUndoStack(undo)
      setRedoStack(redo)
      setCanUndo(undo.length > 0)
      setCanRedo(redo.length > 0)
    })

    return () => {
      unsubscribe()
    }
  }, [appClient])

  return {
    canUndo,
    canRedo,
    undoStack,
    redoStack,
    handleUndo,
    handleRedo,
  }
})

export { UndoRedoProvider, useUndoRedoContext }
